// extracted by mini-css-extract-plugin
export default {"redirect":"not-allowed_redirect__RZXqT","successContent":"not-allowed_successContent__kJFH5"};